import { TThunkAction } from '../../types/redux';
import { TFeature, TFeatureWithPrecision } from '../../types/map';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { updateFeatureProperties } from './updateFeatureProperies';
import { EFeaturesActionType } from './types';

export const setSelectedFeature = actionGenerator<EFeaturesActionType.FeatureSelected, TFeatureWithPrecision>(
  EFeaturesActionType.FeatureSelected,
);

export function selectFeature(feature: TFeature, precision: number): TThunkAction {
  return (dispatch, getState) => {
    const { activeFeature: selectedFeature } = getState();

    dispatch(setSelectedFeature({ ...feature, precision }));

    if (selectedFeature) {
      dispatch(
        updateFeatureProperties({
          featureId: selectedFeature.id,
          precision: selectedFeature.precision,
          properties: { isActive: false },
        }),
      );
    }
    dispatch(updateFeatureProperties({ featureId: feature.id, precision, properties: { isActive: true } }));
  };
}
